module.exports = __webpack_public_path__ + "img/wordmark.bfcb8993.svg";